import { Instruction } from './types';

function isShallowEqual(a: Record<string, unknown>, b: Record<string, unknown>): boolean {
  const aKeys = Object.keys(a).sort();
  const bKeys = Object.keys(b).sort();
  if (aKeys.length !== bKeys.length) {
    return false;
  }
  return aKeys.every((key) => a[key] === b[key]);
}

export function areInstructionsEqual(a: Instruction | null, b: Instruction | null): boolean {
  if (a === b) return true;
  if (a === null || b === null) return false;

  if (a.type !== b.type) return false;

  if (a.type === 'instruction-blocked' && b.type === 'instruction-blocked') {
    return areInstructionsEqual(a.desired, b.desired);
  }

  return isShallowEqual(a, b);
}
